<template>
	<div class="privacy-policy">
		<page-hero
			:carImg="hero.carImg"
			:intro="hero.intro"
			:title="hero.title"
			:subtitle="hero.subtitle"
			:cta="hero.cta"
			:ctaAction="hero.ctaAction"
		/>

		<v-container>
			<section>
				<h1>PRIVACY POLICY</h1>

				<ol class="privacy-lists">
					<div>
						This privacy notice for Hermes Autos, Inc. or any of its
						subsidiaries, such as Hermes Autos Automotive, LLC d/b/a Hermes
						Autos or d/b/a Hermes Autos Logistics, LLC (together, "Hermes
						Autos", "we", "us", or "our") describes how and why we might
						collect, store, use, and/or share ('process') your information when
						you use our services ('Services') such as when you:
						<ul>
							<li>
								Visit our website at https://hermesautos.com, or any website of
								ours that links to this privacy notice.
							</li>
							<li>
								Download and use our mobile application (Hermes Autos mobile
								applications), or any other application of ours that links to
								this privacy notice.
							</li>
							<li>
								Engage with us in other related ways, including any sales,
								marketing, or events
							</li>
						</ul>
						through any Hermes Autos website, including Hermes Autos, and any
						other site "powered by Hermes Autos" (together, "Sites") or Hermes
						Autos mobile applications ("Apps"), as well as offline interactions
						with you. Whenever you use or access the Services in any manner, you
						acknowledge your acceptance to the practices and policies outlined
						below, and consent to our collection, use and sharing of your
						information as described in this Privacy Policy. We reserve the
						rights to manage your use of Hermes Autos’ Services at all times,
						which incorporates the Privacy Policy. All undefined terms maintain
						their definitions stated in the terms of use, unless otherwise
						stated

						<br />
						<br />
						You may print a copy of this Privacy Policy by clicking.
					</div>
					<li class="privacy-list">
						<h2>WHAT INFORMATION DOES HERMES AUTOS COLLECT?</h2>
						<div>
							We collect personal information that you voluntarily provide to us
							when you register on the Services, express an interest in
							obtaining information about us or our products and Services, when
							you participate in activities on the Services, or otherwise when
							you contact us.
						</div>
						<ul>
							<li><b>Personal Information Provided by You.</b></li>
							The personal information that we collect depends on the context of
							your interactions with us and the Services, the choices you make,
							and the products and features you use. The personal information we
							collect include the following: Your government name, email
							address, login information and telephone number. Your address for
							vehicle registration, pickup or delivery, and documents necessary
							for financing or to complete registration, as needed (such as
							driver’s license, title and proof of insurance). Also, we collect
							any further information that you volunteer to us directly or
							through the Services, such as when you communicate with us in
							person or by email, text message, telephone or chat, ask us a
							question, respond to our surveys, post comments, or provide
							reviews or testimonials.
							<li><b>Vehicle Information</b></li>
							In cases where you seek to sell or trade your vehicle to Hermes
							Autos, you may obtain a vehicle appraisal from us through the
							Services. In order to provide an appraisal, we would require and
							collect your Vehicle Identification Number ("VIN") or license
							plate, vehicle history, and details concerning the state of your
							vehicle. We also will request your name and contact information to
							contact you about the appraisal.
							<li><b>Financial Application Information</b></li>
							When you apply for financing for a vehicle purchase from Hermes
							Autos to third-party lenders through the Services, or for a
							pre-qualification for financing, we collect information such as
							your name, email address, telephone number, date of birth,
							address, employment and income information, veteran or military
							status, and social security number. Depending on the lender's
							requirements, we may need to collect additional information from
							you. We also will collect the foregoing information from any
							co-signer on your application.
							<li><b>Credit Report Information</b></li>
							We use a third-party service provider to retrieve credit report
							information from consumer reporting agencies to determine your
							eligibility for financing whenever you apply for pre-qualification
							or financing. This information may include your credit or National
							Identification Number (NIN), Bank Verification Number (BVN) and
							other information in your credit file.
							<li><b>Payment or Other Financial Information</b></li>
							When you sell us a vehicle or make a purchase through the
							Services, we may collect information about your credit card or
							bank account, such as the name and contact information of your
							financial institution, account type, account number, and routing
							number. Your credit card information is processed and stored by a
							third-party service provider. Your bank account information may be
							processed and stored by a third-party service provider.
							<li><b>Commercial Information</b></li>
							When you use the Services, we collect information about the
							transactions you conduct with us, such as vehicle purchases and
							appraisals, and about the vehicles that you have searched for or
							otherwise expressed or indicated an interest in on the Hermes
							Autos Sites or any third-party site.
							<li><b> Information</b></li>
							We may collect geolocation information from you or your device in
							order to tailor our Services to you, for example, showing you
							vehicles closer to your location. You can limit the location
							sharing on your device by accessing the location settings and
							setting your device not to share its location with us.
							<li><b>Information Provided by Third Parties</b></li>
							We may receive information about you from third parties,
							including, without limitation, social media platforms, marketing
							vendors, data analytics companies or data brokers, vehicle history
							services, government agencies, including Departments of Motor
							Vehicles, reputation and identity verification services, and
							insurance companies. In addition, when you view and make inquiries
							about Hermes Autos vehicle listings posted on sites other than the
							Hermes Autos Sites, we will receive the information you submit in
							connection with your inquiry, such as your name, email address or
							phone number.
							<li><b>Information Collected Automatically:</b></li>
							<p>
								We automatically collect certain information when you visit,
								use, or navigate the Services. This information does not reveal
								your specific identity (like your name or contact information)
								but may include device and usage information, such as your IP
								address, browser and device characteristics, operating system,
								language preferences, referring URLs, device name, country,
								location, information about how and when you use our Services,
								and other technical information. This information is primarily
								needed to maintain the security and operation of our Services,
								and for our internal analytics and reporting purposes. Like many
								businesses, we also collect information through cookies and
								similar technologies. We use this information to evaluate and
								improve the Services. These may include, for instance, a unique
								identifier associated with a cookie stored on your browser. It
								may also include a mobile advertising identifier associated with
								your mobile device, such as Apple's Identifier for Advertisers
								("IDFA") and Google's Advertising ID. We may use mobile
								advertising identifiers to collect information for
								interest-based advertising and analytics purposes, as described
								in the section below titled "Analytics and Interest-Based
								Advertising.”
							</p>

							<ul>
								The information we collect includes:
								<li><b>Log and Usage Data</b></li>
								<p>
									Log and usage data is service-related, diagnostic, usage, and
									performance information our servers automatically collect when
									you access or use our Services and which we record in log
									files. Depending on how you interact with us, this log data
									may include your IP address, device information, browser type,
									and settings and information about your activity in the
									Services (such as the date/time stamps associated with your
									usage, pages and files viewed, searches, and other actions you
									take such as which features you use), device event information
									(such as system activity, error reports (sometimes called
									'crash dumps'), and hardware settings).
								</p>
								<li><b>Local Storage </b></li>
								<p>
									We use Local Storage Objects ("LSOs") such as HTML5 to store
									content, information and preferences. However, your browser
									may offer its own management tool to manage LSOs.
								</p>
								<li><b>Device Data</b></li>
								<p>
									We collect device data such as information about your
									computer, phone, tablet, or other device you use to access the
									Services. Depending on the device used, this device data may
									include information such as your IP address (or proxy server),
									device and application identification numbers, location,
									browser type, hardware model, Internet service provider and/or
									mobile carrier, operating system, and system configuration
									information.
								</p>
								<li><b> Location Data</b></li>
								<p>
									We collect location data such as information about your
									device's location, which can be either precise or imprecise.
									How much information we collect depends on the type and
									settings of the device you use to access the Services. For
									example, we may use GPS and other technologies to collect
									geolocation data that tells us your current location (based on
									your IP address). You can opt out of allowing us to collect
									this information either by refusing access to the information
									or by disabling your Location setting on your device. However,
									if you choose to opt out, you may not be able to use certain
									aspects of the Services
								</p>
							</ul>
							<li><b>Application Data</b></li>
							<ul>
								<p>
									If you use our application(s), we also may collect the
									following information if you choose to provide us with access
									or permission:
								</p>
								<li>
									Geolocation Information: We may request access or permission
									to track location-based information from your mobile device,
									either continuously or while you are using our mobile
									application(s), to provide certain location-based services. If
									you wish to change our access or permissions, you may do so in
									your device's settings.
								</li>
								<li>
									Mobile Device Access: We may request access or permission to
									certain features from your mobile device, including your
									mobile device's storage, social media accounts, sms messages,
									and other features. If you wish to change our access or
									permissions, you may do so in your device's settings.
								</li>
								<li>
									Mobile Device Data: We automatically collect device
									information (such as your mobile device ID, model, and
									manufacturer), operating system, version information and
									system configuration information, device and application
									identification numbers, browser type and version, hardware
									model Internet service provider and/or mobile carrier, and
									Internet Protocol (IP) address (or proxy server). If you are
									using our application(s), we may also collect information
									about the phone network associated with your mobile device,
									your mobile device’s operating system or platform, the type of
									mobile device you use, your mobile device’s unique device ID,
									and information about the features of our application(s) you
									accessed.
								</li>
								<li>
									Push Notifications: We may request to send you push
									notifications regarding your account or certain features of
									the application(s). If you wish to opt out from receiving
									these types of communications, you may turn them off in your
									device's settings. This information is primarily needed to
									maintain the security and operation of our application(s), for
									troubleshooting, and for our internal analytics and reporting
									purposes.
								</li>
							</ul>
							<li><b>Feedback and Surveys</b></li>
							<p>
								We, any of our Business Partners or third-party service
								providers may request your participation in surveys or provide
								feedback from time to time in order to improve our services.
								This participation is voluntary and information volunteered in
								this instance will be collected.
							</p>
							<li><b>Resume or Job Application Information:</b></li>
							<p>
								If you submit an application for employment with Hermes Autos,
								we will collect your resume and any other information you
								provide to be considered for a position. In order to submit an
								application, we may direct you to a third-party service provider
								through which you will submit your materials. The specific
								information actually collected by Hermes Autos and its
								third-party service providers will depend on the portion of the
								Services you access.
							</p>
						</ul>
					</li>
					<li class="privacy-list">
						<h2>HOW DOES HERMES AUTOS PROCESS YOUR INFORMATION?</h2>
						<div>
							<p>
								We process your personal information for a variety of reasons,
								depending on how you interact with our Services, including:
							</p>

							<ul>
								<li>
									To facilitate account creation and authentication and
									otherwise manage user accounts. We may process your
									information so you can create and log in to your account, as
									well as keep your account in working order.
								</li>
								<li>
									To act on your behalf to access and transmit your personal and
									financial information from the relevant financial institution
									through the services of companies with whom we often partner
									with. By using the Services, you agree to your personal and
									financial information being transferred, stored, and processed
									by these companies in accordance with their privacy policies.
								</li>
								<li>
									To deliver and facilitate delivery of services to the user. We
									may process your information to provide you with the requested
									service.
								</li>
								<li>
									To respond to user inquiries/offer support to users. We may
									process your information to respond to your inquiries and
									solve any potential issues you might have with the requested
									service.
								</li>
								<li>
									To send administrative information to you. We may process your
									information to send you details about our products and
									services, changes to our terms and policies, and other similar
									information.
								</li>
								<li>
									To fulfill and manage your orders. We may process your
									information to fulfill and manage your orders, payments,
									returns, and exchanges made through the Services.
								</li>
								<li>
									To request feedback. We may process your information when
									necessary to request feedback and to contact you about your
									use of our Services.
								</li>
								<li>
									To send you marketing and promotional communications. We may
									process the personal information you send to us for our
									marketing purposes, if this is in accordance with your
									marketing preferences. You can opt out of our marketing emails
									at any time. For more information, see 'WHAT ARE YOUR PRIVACY
									RIGHTS?' below.
								</li>
								<li>
									To deliver targeted advertising to you. We may process your
									information to develop and display personalized content and
									advertising tailored to your interests, location, and more.
								</li>
								<li>
									To protect our Services. We may process your information as
									part of our efforts to keep our Services safe and secure,
									including fraud monitoring and prevention.
								</li>
								<li>
									To evaluate and improve our Services, products, marketing, and
									your experience. We may process your information when we
									believe it is necessary to identify usage trends, determine
									the effectiveness of our promotional campaigns, and to
									evaluate and improve our Services, products, marketing, and
									your experience.
								</li>
								<li>
									To identify usage trends. We may process information about how
									you use our Services to better understand how they are being
									used so we can improve them.
								</li>
								<li>
									To determine the effectiveness of our marketing and
									promotional campaigns. We may process your information to
									better understand how to provide marketing and promotional
									campaigns that are most relevant to you.
								</li>
								<li>
									To comply with our legal obligations. We may process your
									information to comply with our legal obligations, respond to
									legal requests, and exercise, establish, or defend our legal
									rights.
								</li>
							</ul>
						</div>
					</li>
					<li class="privacy-list">
						<h2>
							WHEN AND WITH WHOM DOES HERMES AUTOS SHARE YOUR INFORMATION?
						</h2>
						<p>
							We may share your data with third-party vendors, service
							providers, contractors, or agents ('third parties') who perform
							services for us or on our behalf and require access to such
							information to do that work.
						</p>
						<p>
							We do this with the following entities for the under listed
							purposes:
						</p>
						<ul>
							<li>
								<b>Affiliates: </b>We may share your information with our
								affiliates, in which case we will require those affiliates to
								honour this privacy notice. Affiliates include our parent
								company and any subsidiaries, joint venture partners, or other
								companies that we control or that are under common control with
								us.
							</li>
							<li>
								<b>Service Providers: </b>Third-party service providers, such as
								the following, require that we share your information with them
								to enable them perform services on our behalf:
								<ul>
									<li>Vehicle inspectors</li>
									<li>Vehicle history providers</li>
									<li>Reconditioning service providers</li>
									<li>Suppliers</li>
									<li>Sales management database providers</li>
									<li>Customer contact center and phone support providers</li>
									<li>Payment processors</li>
									<li>Credit check providers</li>
									<li>Lenders</li>
									<li>Financing services companies</li>
									<li>Shipping providers</li>
									<li>Email and other marketing and promotion vendors</li>
									<li>Customer data aggregator platforms</li>
									<li>Media and marketing agencies</li>
									<li>Web hosting services</li>
									<li>Operating systems and platforms</li>
									<li>Data analytics and advertising providers</li>
									<li>Survey providers</li>
								</ul>
							</li>
							<li>
								<b>Government Agencies: </b> Hermes Autos may share your
								information with government agencies, such as the Directorate of
								Motor Vehicle Administration, in order to complete your
								transaction(s).
							</li>
							<li>
								<b>Business Partners: </b>We may share your information with our
								“business partners”; vendors, lenders, financial services
								companies, vehicle listing and advertising platforms, and other
								third parties with whom we are commercially related to offer you
								certain products, services, or promotions, for benchmarking and
								data analytics by Hermes Autos or our Business Partners; or to
								manage our business. We particularly share your credit
								application details with certain Business Partners in cases when
								you request financing. Certain Business Partners such as the
								operators of sites “powered by Hermes Autos.” may use certain of
								your information in accordance with their own privacy policies.
							</li>
							<li>
								<b>Third-Party Plugins: </b>The Services integrate certain
								third-party plugins. These plugins may collect information, such
								as your IP address and the pages that you view even if you do
								not click on it; they may set and/or access a cookie. These
								plugins operate by the privacy policy of the source company.
							</li>
							<li>
								<b>Other Users or the Public: </b>Your reviews and testimonials
								may be publicly viewable or viewable by anyone who uses the
								Services. Therefore, if you upload or share any information as
								part of a review or testimonial, unless otherwise expressly
								stated by Hermes Autos, such information may become publicly
								available. This means that the information may be collected,
								used, or redistributed by others, so please proceed with caution
								before providing any sensitive or confidential information as
								part of a review or testimonial.
							</li>
							<li>
								<b>Customized Audiences and Similar Programs: </b>We may partner
								with Facebook, Google and other social media and social
								marketing partners to deliver advertisements to our users via
								the Facebook Custom Audiences program, Google Customer Match or
								similar third-party programs. In order to identify and reach our
								users on Facebook, Google or another third-party service, we may
								share your information with Facebook, Google or another
								third-party service. For more information about custom audience
								targeting and how to adjust your social media advertising
								preferences, please review the privacy policy of your social
								media or social marketing providers.
							</li>
							<li>
								<b>Legal Purposes: </b>Hermes Autos also may use or share your
								information with third parties when, in our sole discretion, we
								believe doing so is necessary:
								<ul>
									<li>
										To comply with applicable law or a court order, subpoena, or
										other legal process;
									</li>
									<li>
										To investigate, prevent, or take action regarding illegal
										activities, suspected fraud, violations of our terms and
										conditions, or situation involving threats to our property
										or the property or physical safety of any person or third
										party; or
									</li>
									<li>
										To establish, protect, or exercise our legal rights or
										defend against legal claims.
									</li>
								</ul>
							</li>
							<li>
								<b>Organizational Transfers: </b>We also may need to share your
								personal information in the following situations:
							</li>
							<li>
								<b>Business Transfers:</b>e may share or transfer your
								information in connection with, or during negotiations of, any
								merger, sale of company assets, financing, or acquisition of all
								or a portion of our business to another company. You consent
								that such sharing and transfers may occur, and that any acquirer
								of us or our assets may continue to use your information as
								governed by this Policy.
							</li>
							<li>
								<b>Aggregated and De-Identified Information: </b>From time to
								time, we may share aggregated or de-identified information about
								users, such as by publishing reports on trends in the usage of
								the Services.
							</li>
						</ul>
					</li>
					<li class="privacy-list">
						<h2>
							DOES HERMES AUTOS USE COOKIES AND OTHER TRACKING TECHNOLOGIES?
						</h2>
						<p>
							We may use cookies and similar tracking technologies (like web
							beacons and pixels) to access or store information.
						</p>
						<p>
							We partner with certain third parties to collect information to
							engage in analytics, auditing, research and reporting.
						</p>
						<p>
							third parties may use server logs, web beacons, tags, pixels,
							mobile advertising IDs (such as Apple's IDFA or Google's
							Advertising ID), and similar technologies, and they may set and
							access cookies on your computer or other device. In instance, when
							we use Google Analytics. We may share your information with Google
							Analytics to track and analyze the use of the Services. To opt out
							of being tracked by Google Analytics across the Services, visit
							https://tools.google.com/dlpage/gaoptout. For more information on
							the privacy practices of Google, please visit the Google Privacy &
							Terms page.
						</p>
						<p>
							When we use Google Maps Platform APIs. We may share your
							information with certain Google Maps Platform APIs (e.g. Google
							Maps API, Places API). We obtain and store on your device
							('cache') your location. You may revoke your consent anytime by
							contacting us at the contact details provided at the end of this
							document.
						</p>

						<p>
							You may learn more about Google Analytics' data practices by
							clicking here . and opt out of the use of cookies in web browsers
							by Google Analytics by reading more here .
						</p>
						<p>
							We may also use analytics providers that engage in heat mapping
							and that record mouse movements, clicks, scrolls, and keystrokes
							during your use of the Services. These analytics help us identify
							and address technical issues and understand usage of our Services,
							which we use to improve the Services for you.
						</p>
						<p>
							We also partner with third parties to provide targeted advertising
							services that are customized based on your online activities over
							time and across unaffiliated websites, mobile apps and devices
							(commonly referred to as "interest-based advertising"). Our
							advertising partners may collect information about your activities
							on our Services on your current device and combine it with
							information about your activities on other websites, mobile apps,
							and devices. They may collect such information using server logs,
							cookies, web beacons, tags, pixels, mobile advertising IDs (such
							as Apple's IDFA or Google's Advertising ID), cross-device linking,
							and similar technologies. For example, our advertising partners
							may use the fact that you visited our Sites to target advertising
							to you on non-Hermes Autos websites and mobile apps on your
							current device or on other devices you use. For information about
							interest-based advertising practices, including privacy and
							confidentiality, visit the Network Advertising Initiative website
							or the Digital Advertising Alliance website.
						</p>
						<p>
							The use of online tracking mechanisms by third parties is subject
							to those third parties' own privacy policies, and not this Policy.
							You can opt out of interest-based advertising in web browsers and
							mobile apps on your current browser or device by following the
							instructions below.
						</p>

						<ul>
							<li>
								<b>Web Browser Opt-Out: </b>To opt out in web browsers, please
								visit optout.aboutads.info and optout.networkadvertising.org. To
								help preserve your choices, you can install the "Protect My
								Choices" extension that is available at
								<a
									href="http://www.aboutads.info/PMC."
									target="_blank"
									rel="noopener noreferrer"
								>
									http://www.aboutads.info/PMC.</a
								>
							</li>
							<li>
								<b>Mobile Application Opt-Out: </b>To opt out in mobile apps,
								you can adjust the advertising preferences on your mobile
								device. For example:

								<ul>
									<li>
										In iOS 7+, visit Settings > Privacy > Advertising > Limit Ad
										Tracking.
									</li>
									<li>
										In Android, visit Settings > Google > Ads > Opt out of
										interest-based ads or Opt out of Personalized Advertising.
									</li>
								</ul>
							</li>
							<br />
							<p>
								You can also opt out for participating companies by downloading
								the Digital Advertising Alliance's AppChoices tool at and
								following the instructions in the app. For more information
								about opting out on mobile devices, please click . Please note
								that the opt-outs described above are browser-specific,
								therefore you will need to opt out separately on all of your
								browsers and devices. If you delete or reset your cookies or
								mobile advertising identifiers, change or upgrade current
								browsers, or use a different device, any opt-out cookie or tool
								may no longer work and you will need to opt out again. If you
								choose to opt out, you will still see advertisements while
								browsing online, however the advertisements may be less relevant
								to you and your interests. Although our Services currently do
								not respond to "do not track" browser headers, you can limit
								tracking by these third parties and by taking the steps
								discussed above.
							</p>
						</ul>
					</li>

					<li>
						<h2>HOW CAN YOU LIMIT OUR INFORMATION COLLECTION AND/OR USE?</h2>
						<p>
							You can limit our collection and/or use of your information
							through several means, including:
						</p>
						<ul>
							<li>
								<b>Limiting Information provided to Hermes Autos: </b>The choice
								to disclose to or withhold certain information from us always
								remains yours; provision of certain information is however
								required to be able to access certain features or services.
							</li>
							<li>
								<b>Your choices for Advertising:</b>You can disallow the
								collection of information by certain third parties as described
								in the section above titled "Analytics and Interest-Based
								Advertising." Most Web browsers are set to accept cookies by
								default. If you prefer, you can usually choose to set your
								browser to remove cookies and to reject cookies. If you choose
								to remove cookies or reject cookies, this could affect certain
								features or services of our Services and your experience of the
								same. Asides managing your browser cookies you may also control
								targeted advertising by clicking on “Do Not Sell or Share My
								Personal Information” and filling out the form therein.
							</li>
							<li>
								<b>Marketing: </b>You can unsubscribe from our marketing and
								promotional communications at any time by clicking on the
								unsubscribe link in the emails that we send, replying 'STOP' or
								'UNSUBSCRIBE' to the SMS messages that we send, or by contacting
								us using the details provided in the section 'HOW CAN YOU
								CONTACT US ABOUT THIS NOTICE?' below. You will then be removed
								from the marketing lists. However, we may still communicate with
								you — for example, to send you service-related messages that are
								necessary for the administration and use of your account, to
								respond to service requests, or for other non-marketing
								purposes.
							</li>
						</ul>
					</li>

					<li>
						<h2>HOW LONG DO WE KEEP YOUR INFORMATION FOR?</h2>
						<p>
							We will only keep your personal information for as long as it is
							necessary for the purposes set out in this privacy notice, unless
							a longer retention period is required or permitted by law (such as
							tax, accounting, or other legal requirements). No purpose in this
							notice will require us to keep your personal information for
							longer than the period of time in which users have an account with
							us.
						</p>
						<p>
							When we have no ongoing legitimate business need to process your
							personal information, we will either delete or anonymise such
							information, or, if this is not possible (for example, because
							your personal information has been stored in backup archives),
							then we will securely store your personal information and isolate
							it from any further processing until deletion is possible.
						</p>
					</li>

					<li>
						<h2>Third-Party Links</h2>
						<p>
							The Services may contain links to third-party websites. If you
							follow a link to any of these websites, please note that these
							websites, and any services that may be accessible through them,
							have their own privacy policies. We declare that we are not
							responsible for the privacy practices of other websites. We
							encourage you therefore to be aware when you use the Services and
							to read the privacy policies applicable to such third-party
							websites. This Privacy Policy applies solely to information
							collected in connection with the Services of Hermes Autos.
						</p>
					</li>
					<li>
						<h2>HOW DO WE KEEP YOUR INFORMATION SAFE?</h2>
						<p>
							We have implemented appropriate and reasonable technical and
							organizational security measures designed to protect the security
							of any personal information we process. However, despite our
							safeguards and efforts to secure your information, no electronic
							transmission over the Internet or information storage technology
							can be guaranteed to be 100% secure, so we cannot promise or
							guarantee that hackers, cybercriminals, or other unauthorized
							third parties will not be able to defeat our security and
							improperly collect, access, steal, or modify your information.
						</p>
					</li>

					<li>
						<h2>Children's Policy</h2>
						<p>
							The services are not intended or directed to individuals under the
							age of 18. We request that such individuals do not provide
							information to us through any of the Services. Please contact us
							at the address below if you have reason to suspect that we
							collected personal information from a child under the age of 18.
						</p>
					</li>

					<li>
						<h2>CONTROLS FOR DO-NOT-TRACK FEATURES</h2>
						<p>
							Most web browsers and some mobile operating systems and mobile applications include a Do-Not-Track ('DNT') feature or setting you can activate to signal your privacy preference not to have data about your online browsing activities monitored and collected. At this stage no uniform technology standard for recognising and implementing DNT signals has been finalized. As such, we do not currently respond to DNT browser signals or any other mechanism that automatically communicates your choice not to be tracked online. If a standard for online tracking is adopted that we must follow in the future, we will inform you about that practice in a revised version of this privacy notice.
						</p>
					</li>
					<li>
						<h2>DOES HERMES AUTOS MAKE UPDATES TO THIS NOTICE?
</h2>
						<p>
							We may update this privacy notice from time to time. The updated version will be indicated by an updated 'Revised' date and the updated version will be effective as soon as it is accessible. If we make material changes to this privacy notice, we may notify you either by prominently posting a notice of such changes or by directly sending you a notification. Also, amendments may take effect immediately or as required by law and without any prior notice. We encourage you to review this privacy notice frequently to be informed of how we are protecting your information.

						</p>
					</li>

					<li>
						<h2>HOW CAN YOU CONTACT HERMES AUTOS ABOUT THIS NOTICE?
</h2>
						<p>
							Thanks for your attention to our Privacy Policy. We value our customers and are committed to protecting your personal information. If you have questions regarding this Privacy Policy, please contact us at: Hermes Autos, Inc., Please note that only inquiries involving Hermes Autos’ Privacy Policy should be sent to this address. No other communication will be accepted or addressed. To opt-out of receiving promotional emails from us, please click on the "Unsubscribe" link contained at the bottom of each promotional email. If you wish to opt-out of receiving text messages, please respond "STOP" to the text message you have received.

						</p>
					</li>
				</ol>

				<div>
					<small>
						Dents or dents greater than four (4) inches in diameter, not placed
						in an accessible region, or not repairable by the paintless dent
						repair procedure. Repairs that will impact or damage the paint or
						finish of the vehicle. Vandalism has caused significant damage.
						There may be other exclusions. Specific coverage specifics,
						including limits and exclusions, can be found in your Product
						Agreement.
					</small>
				</div>
			</section>
		</v-container>
	</div>
</template>

<script>
	import pageHero from "../components/pageHero";

	export default {
		components: {
			pageHero,
		},
		data() {
			return {
				hero: {
					carImg: require("../assets/img/gle-benz.png"),
					intro: "",
					title: "Rules of the Road",
					subtitle:
						"Hermes Autos's mission is to help you find your drive. Please make a pit stop here to learn more about the terms and policies that govern your use of our products and services.",
					cta: "Find Your Car",
					ctaAction: "https://shop.hermesautos.com",
				},
			};
		},
	};
</script>

<style scoped>
	section {
		padding: 40px 0;
	}
</style>
